const ROLE_TOKEN = /^role-(violet|blue|cyan|mint|amber|coral|rose|slate)$/;

/** Resolves a role color (token name like `role-violet`, or a CSS color) to a CSS value. */
export function roleColor(color: string | null | undefined, fallback = 'var(--text-primary)'): string {
  if (!color) return fallback;
  if (ROLE_TOKEN.test(color)) return `var(--${color})`;
  if (color.startsWith('--')) return `var(${color})`;
  return color;
}

/** Deterministic hue (0–359) from a string — used for initials avatars without art or upload. */
export function hueFromString(value: string): number {
  let h = 0;
  for (let i = 0; i < value.length; i++) h = (h * 31 + value.charCodeAt(i)) >>> 0;
  return h % 360;
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '?';
  const second = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + second).toLocaleUpperCase('tr-TR');
}
